var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticStyle:{"cursor":"pointer"},attrs:{"align":"center","justify":"center"}},[_c('v-img',{staticClass:"grey lighten-2",attrs:{"src":require("@/assets/kahoot.jpg"),"width":"100%"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }